(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  var GEM_COPY = {
    'Aventurina Verde': 'Tradicionalmente vinculada a la prosperidad y la buena fortuna, la aventurina verde aporta un tono suave y natural a cada pieza.',
    'Amatista': 'Asociada a la calma y la claridad mental, la amatista destaca por su color violeta profundo y sus vetas naturales.',
    'Apatita': 'Vinculada a la motivación y el crecimiento personal, la apatita ofrece un azul verdoso luminoso y poco común.',
    'Amazonita': 'Relacionada con el equilibrio emocional, la amazonita se reconoce por su verde azulado sereno.',
    'Crisoprasa': 'Asociada a la renovación, la crisoprasa aporta un verde manzana suave y translúcido.',
    'Fluorita Lila': 'Vinculada a la concentración, la fluorita lila destaca por sus tonos violetas y su transparencia natural.',
    'Fluorita Verde': 'Asociada al orden y la toma de decisiones, la fluorita verde combina transparencia y un verde fresco.',
    'Granate': 'Relacionado con la vitalidad, el granate aporta un rojo intenso y profundo a cada pieza.',
    'Granate Verde': 'Una variante poco común del granate, vinculada a la abundancia, con un verde intenso característico.',
    'Ágata India': 'Asociada a la estabilidad, el ágata india se distingue por sus bandas naturales en tonos tierra.',
    'Kynita': 'Vinculada a la comunicación y la claridad interior, la cianita destaca por su azul intenso en forma de láminas naturales.',
    'Labradorita': 'Reconocida por su juego de luces iridiscente, la labradorita se asocia tradicionalmente a la intuición.',
    'Lapislázuli': 'Vinculado a la sabiduría desde la antigüedad, el lapislázuli destaca por su azul profundo con vetas doradas.',
    'Larimar': 'Procedente del Caribe, el larimar se asocia a la serenidad y recuerda al color del mar.',
    'Lapislázuli II': 'Vinculado a la sabiduría desde la antigüedad, el lapislázuli destaca por su azul profundo con vetas doradas.',
    'Malaquita': 'Asociada a la transformación, la malaquita se reconoce por sus bandas de verdes concéntricas.',
    'Turquesa Natural': 'Una de las gemas más antiguas usadas en joyería, la turquesa se asocia tradicionalmente a la protección.',
    'Naranja Jade': 'Vinculada a la vitalidad y la alegría, esta variedad de jade aporta un cálido tono naranja.',
    'Ópalo Rosa': 'Asociado al amor propio, el ópalo rosa aporta una suave luminosidad en tonos rosados.',
    'Ojo de Tigre': 'Vinculada a la fortaleza interior, esta gema se talla a mano honrando la belleza natural de sus bandas.',
    'Ónix Negra': 'Asociado a la protección, el ónix se reconoce por su negro profundo y opaco.',
    'Piedra del Sol': 'Vinculada al optimismo, la piedra del sol brilla con destellos dorados naturales.',
    'Rodocrosita': 'Asociada al amor propio, la rodocrosita destaca por sus tonos rosados con vetas blancas.',
    'Rubí': 'Símbolo de pasión desde la antigüedad, el rubí aporta un rojo intenso y vibrante.',
    'Rubí-Zoisita': 'Una combinación natural de rubí y zoisita, vinculada a la vitalidad, con un contraste de rojo y verde.',
    'Piedra del Sol de Arusha': 'Procedente de Arusha, esta variedad de piedra del sol se asocia a la luminosidad y el optimismo.',
    'Piedra del Sol II': 'Vinculada al optimismo, la piedra del sol brilla con destellos dorados naturales.',
    'Turmalina': 'Conocida por su amplia variedad de colores, la turmalina se asocia tradicionalmente al equilibrio energético.',
    'Turquesa': 'Una de las gemas más antiguas usadas en joyería, la turquesa se asocia tradicionalmente a la protección.',
    'Turmalina Verde': 'Asociada al crecimiento, la turmalina verde destaca por su tono verde intenso y su brillo natural.',
    'Auralita': 'Una gema poco común, vinculada a la introspección y la calma.',
    'Diópsido Verde': 'Asociado a la vitalidad, el diópsido verde se reconoce por su verde intenso y su brillo natural.',
    'Azurita': 'Vinculada a la intuición, la azurita destaca por su azul profundo, a menudo junto a vetas de malaquita.',
    'Agata Dendrítica': 'Asociada a la conexión con la naturaleza, el ágata dendrítica muestra inclusiones que recuerdan a formas vegetales.',
    'Onix Negro': 'Asociado a la protección, el ónix se reconoce por su negro profundo y opaco.',
    'Rodonita': 'Vinculada a la compasión, la rodonita destaca por su rosa intenso con vetas negras naturales.'
  };
  var ACABADO_COPY = { 'Oro': 'Color oro', 'Plata': 'Color plata', 'Acero': 'Acero natural' };

  function updateGemCopy(val) {
    var gemLabelEl = document.querySelector('[data-gem-label]');
    var gemCopyEl = document.querySelector('[data-gem-copy]');
    if (gemLabelEl) gemLabelEl.textContent = val;
    if (gemCopyEl && GEM_COPY[val]) gemCopyEl.textContent = GEM_COPY[val];
  }
  function updateAcabado(val) {
    var acabadoEl = document.querySelector('[data-acabado-label]');
    if (acabadoEl && ACABADO_COPY[val]) acabadoEl.textContent = ACABADO_COPY[val];
  }

  var signoSelect = document.querySelector('[data-signo-select]');
  if (signoSelect) {
    signoSelect.querySelectorAll('[data-signo-url]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-signo-url');
        if (url && !btn.classList.contains('is-active')) window.location.href = url;
      });
    });
  }

  var form = document.querySelector('[data-product-form]');
  if (form) {
    var colorSelect = form.querySelector('[data-color-select]');
    var sizeSelect = form.querySelector('[data-size-select]');
    var script = form.querySelector('[data-pd-variants]');
    var idInput = form.querySelector('[data-variant-id]');
    var cta = form.querySelector('[data-pd-cta]');
    var ctaLabel = cta && cta.querySelector('[data-cta-label]');
    var priceEl = document.querySelector('[data-pd-price]');
    var galleryImg = document.querySelector('.pd-gallery img');

    function money(cents) { return Math.round(cents / 100) + ' €'; }

    if ((colorSelect || sizeSelect) && script && idInput && cta) {
      var variants = [];
      try { variants = JSON.parse(script.textContent); } catch (e) { variants = []; }
      var selected = {};
      var required = [];
      if (colorSelect) required.push(parseInt(colorSelect.getAttribute('data-color-index'), 10));
      if (sizeSelect) required.push(parseInt(sizeSelect.getAttribute('data-size-index'), 10));

      function findMatch() {
        return variants.find(function (v) {
          return required.every(function (idx) {
            return String(v['option' + (idx + 1)]) === selected[idx];
          });
        });
      }

      function applyMatch(updateGallery) {
        if (required.some(function (idx) { return !(idx in selected); })) return;
        var match = findMatch();
        if (!match) return;
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (updateGallery !== false && galleryImg && match.featured_image && match.featured_image.src) {
          galleryImg.src = match.featured_image.src;
          var galleryEl = document.querySelector('[data-pd-gallery]');
          if (galleryEl) galleryEl.classList.add('pd-gallery--variant-preview');
        }
        if (match.available) {
          cta.disabled = false;
          if (ctaLabel) ctaLabel.textContent = 'Añadir a la cesta';
        } else {
          cta.disabled = true;
          if (ctaLabel) ctaLabel.textContent = 'Agotado';
        }
      }

      if (colorSelect) {
        var colorIdx = parseInt(colorSelect.getAttribute('data-color-index'), 10);
        colorSelect.querySelectorAll('.swatch').forEach(function (btn) {
          btn.addEventListener('click', function () {
            colorSelect.querySelectorAll('.swatch').forEach(function (b) { b.removeAttribute('data-active'); });
            btn.setAttribute('data-active', '');
            var val = btn.getAttribute('data-color-value');
            selected[colorIdx] = val;
            updateAcabado(val);
            applyMatch();
          });
        });
        var activeSwatch = colorSelect.querySelector('.swatch[data-active]');
        if (activeSwatch) selected[colorIdx] = activeSwatch.getAttribute('data-color-value');
      }

      if (sizeSelect && sizeSelect.hasAttribute('data-stone-dropdown')) {
        var stoneIdx = parseInt(sizeSelect.getAttribute('data-size-index'), 10);
        var stoneTrigger = sizeSelect.querySelector('[data-stone-trigger]');
        var stonePanel = sizeSelect.querySelector('[data-stone-panel]');
        var stoneLabel = sizeSelect.querySelector('[data-stone-trigger-label]');
        var stoneDot = sizeSelect.querySelector('[data-stone-trigger-dot]');
        var firstStoneOption = sizeSelect.querySelector('.pd-stone-option');
        if (stoneDot && firstStoneOption) {
          stoneDot.style.backgroundColor = getComputedStyle(firstStoneOption.querySelector('.pd-stone-dot')).backgroundColor;
        }
        if (firstStoneOption) selected[stoneIdx] = firstStoneOption.getAttribute('data-size-value');
        updateGemCopy(selected[stoneIdx]);

        function closeStonePanel() {
          sizeSelect.classList.remove('is-open');
          stonePanel.classList.remove('is-visible');
          stoneTrigger.setAttribute('aria-expanded', 'false');
        }
        function openStonePanel() {
          sizeSelect.classList.add('is-open');
          stonePanel.classList.add('is-visible');
          stoneTrigger.setAttribute('aria-expanded', 'true');
        }
        stoneTrigger.addEventListener('click', function (e) {
          e.stopPropagation();
          if (sizeSelect.classList.contains('is-open')) closeStonePanel(); else openStonePanel();
        });
        document.addEventListener('click', function (e) {
          if (!sizeSelect.contains(e.target)) closeStonePanel();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') closeStonePanel();
        });

        sizeSelect.querySelectorAll('.pd-stone-option').forEach(function (opt) {
          opt.addEventListener('click', function () {
            var val = opt.getAttribute('data-size-value');
            sizeSelect.querySelectorAll('.pd-stone-option').forEach(function (o) {
              o.classList.remove('is-selected');
              o.setAttribute('aria-selected', 'false');
            });
            opt.classList.add('is-selected');
            opt.setAttribute('aria-selected', 'true');
            if (stoneLabel) stoneLabel.textContent = val;
            if (stoneDot) stoneDot.style.backgroundColor = getComputedStyle(opt.querySelector('.pd-stone-dot')).backgroundColor;
            selected[stoneIdx] = val;
            updateGemCopy(val);
            applyMatch();
            closeStonePanel();
          });
        });
      } else if (sizeSelect) {
        var sizeIdx = parseInt(sizeSelect.getAttribute('data-size-index'), 10);
        sizeSelect.querySelectorAll('.pd-size-btn').forEach(function (btn) {
          var val = btn.getAttribute('data-size-value');
          btn.addEventListener('click', function () {
            if (btn.classList.contains('is-soldout')) return;
            sizeSelect.querySelectorAll('.pd-size-btn').forEach(function (b) { b.classList.remove('is-active'); });
            btn.classList.add('is-active');
            selected[sizeIdx] = val;
            updateGemCopy(val);
            applyMatch();
          });
        });
        var activeSizeBtn = sizeSelect.querySelector('.pd-size-btn.is-active');
        if (activeSizeBtn) selected[sizeIdx] = activeSizeBtn.getAttribute('data-size-value');
        updateGemCopy(selected[sizeIdx]);
      }

      applyMatch(false);
    }
  }

  // Gallery scroll progress bar
  var gallery = document.querySelector('[data-pd-gallery]');
  var bar = document.querySelector('[data-gallery-bar]');
  if (gallery && bar) {
    var count = gallery.children.length;
    var update = function () {
      var trackWidth = bar.parentElement.clientWidth;
      var thumbWidth = Math.max(trackWidth / count, 24);
      var max = gallery.scrollWidth - gallery.clientWidth;
      var progress = max > 0 ? gallery.scrollLeft / max : 0;
      bar.style.width = thumbWidth + 'px';
      bar.style.transform = 'translateX(' + (progress * (trackWidth - thumbWidth)) + 'px)';
    };
    gallery.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // Click-to-zoom lightbox with carousel — every product photo is loaded into
  // the stage up front and stacked behind the active one (opacity+scale), so
  // switching images crossfades/scales forward instead of a hard swap.
  var lightbox = document.querySelector('[data-pd-lightbox]');
  if (lightbox) {
    var stage = lightbox.querySelector('[data-pd-lightbox-stage]');
    var lbClose = lightbox.querySelector('[data-pd-lightbox-close]');
    var prevBtn = lightbox.querySelector('[data-pd-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-pd-lightbox-next]');
    var sourceImgs = Array.prototype.slice.call(document.querySelectorAll('[data-pd-zoomable]'));
    var activeIndex = 0;

    var closeZoom = function () {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };

    var lbImgs = sourceImgs.map(function (img) {
      var el = document.createElement('img');
      el.src = img.currentSrc || img.src;
      el.alt = img.alt || '';
      el.addEventListener('click', closeZoom);
      stage.appendChild(el);
      return el;
    });
    lightbox.setAttribute('data-count', lbImgs.length);

    function render() {
      lbImgs.forEach(function (el, i) { el.classList.toggle('is-active', i === activeIndex); });
    }
    function openZoom(index) {
      activeIndex = index;
      render();
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }
    function go(delta) {
      if (!lbImgs.length) return;
      activeIndex = (activeIndex + delta + lbImgs.length) % lbImgs.length;
      render();
    }

    sourceImgs.forEach(function (img, i) {
      img.addEventListener('click', function () { openZoom(i); });
    });
    lbClose.addEventListener('click', closeZoom);
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target === stage) closeZoom();
    });
    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeZoom();
      if (e.key === 'ArrowRight') go(1);
      if (e.key === 'ArrowLeft') go(-1);
    });
  }

  // Ring size guide modal
  var guideModal = document.querySelector('[data-size-guide-modal]');
  if (guideModal) {
    var guideOpenBtn = document.querySelector('[data-size-guide-open]');
    var guideCloseBtn = guideModal.querySelector('[data-size-guide-close]');
    var openGuide = function () {
      guideModal.classList.add('is-open');
      guideModal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    };
    var closeGuide = function () {
      guideModal.classList.remove('is-open');
      guideModal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };
    if (guideOpenBtn) guideOpenBtn.addEventListener('click', function (e) { e.preventDefault(); openGuide(); });
    if (guideCloseBtn) guideCloseBtn.addEventListener('click', closeGuide);
    guideModal.addEventListener('click', function (e) { if (e.target === guideModal) closeGuide(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeGuide(); });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
